import {Box} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import NoPreview from './thumbnail-no-preview.jsx';

const ThumbnailImage = ({altText, src, errorSize, ...props}) => {
  if (src) {
    return (
      <Box
        component="img"
        src={src}
        draggable={false}
        alt={altText || ''}
        {...props}
        sx={[
          {
            width: '100%',
            height: 'auto',
          },
          ...(Array.isArray(props.sx) ? props.sx : [props.sx]),
        ]}
      />
    );
  }
  return <NoPreview errorSize={errorSize} {...props} />;
};

ThumbnailImage.propTypes = {
  altText: PropTypes.string,
  src: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  errorSize: PropTypes.string,
  sx: PropTypes.object,
};

export default ThumbnailImage;
